import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import PS from "./ProjectScopeActionsNew";

const ProjectScopeCardViewSwitchers = (props) => {

  const {updateFeatureGroup, featureGroup} = props;
  const {displayType} = featureGroup;

  const handleSwitcherButtonClick = (event) => {
    featureGroup.displayType = +event.target.dataset.view;
    updateFeatureGroup(featureGroup);
  };

  return (
    <div className="pj-scope-lir-switchers">
      <button className={"ui-switcher" + (displayType === 1 ? " ui-switcher--active" : "")}
              data-view={1} onClick={handleSwitcherButtonClick}>
        <span/>
      </button>
      <button className={"ui-switcher" + (displayType === 2 ? " ui-switcher--active" : "")}
              data-view={2} onClick={handleSwitcherButtonClick}>
        <p><span/><span/><span/></p>
        <p><span/><span/><span/></p>
      </button>
      <button className={"ui-switcher" + (!displayType || (displayType === 3) ? " ui-switcher--active" : "")}
              data-view={3} onClick={handleSwitcherButtonClick}>
        <p><span/><span/><span/></p>
        <p><span/><span/><span/></p>
        <p><span/><span/><span/></p>
      </button>
      <button className={"ui-switcher" + (displayType === 4 ? " ui-switcher--active" : "")}
              data-view={4} onClick={handleSwitcherButtonClick}>
        <p><span/></p>
        <p><span/></p>
        <p><span/></p>
      </button>
    </div>
  )
};

ProjectScopeCardViewSwitchers.propTypes = {
  featureGroup: PropTypes.object.isRequired
}

const mapStateToProps = () => {
  return {

  };
};

function mapDispatchToProps(dispatch) {
  return {
    updateFeatureGroup: (featureGroup) => dispatch(PS.updateFeatureGroup(featureGroup)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectScopeCardViewSwitchers);
